import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Paper, Typography, CircularProgress, TextField, MenuItem, Checkbox, Pagination, InputAdornment } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import './certificates.css'
import AddCerificate from './AddCertificate';
import Modal from 'react-bootstrap/Modal';
import ViewCertificate from './ViewCertificate';
import PageLoader from '../../components/PageLoader/PageLoader';
import CalendarLoader from '../../components/Calendar/CalendarLoader';
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";

const Certificates = () => {
  const [addModal, setAddModal] = useState(false);
  const [certificates, setCertificates] = useState([])
  const [deletModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState('')
  const [viewModal, setViewModal] = useState(false)
  const [viewId, setViewId] = useState('')
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState('');
  const itemsPerPage = 6;

  const loadCertificates = (showLoader = false, showLoader2 = false) => {
    if (showLoader) {
      setLoading(true);
    }

    ApiService.get(`/get-certificates?page=${currentPage}&limit=${itemsPerPage}&search=${searchResult}`)
      .then(({ data }) => {
        setCertificates(data?.data?.data || []);
        setTotalPages(Math.ceil(data.data.total / itemsPerPage));
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      })
  }

  const deleteCertificate = () => {
    setLoading(true);
    ApiService.get('/delete-certificate/' + deleteId)
      .then(({ data }) => {
        setDeleteId('')
        setDeleteModal(false)
        toast.success(data.message)
        loadCertificates()
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message)
      })
  }

  useEffect(() => {
    const showLoader = !searchResult;
    const showLoader2 = !currentPage;
    loadCertificates(showLoader, showLoader2);
  }, [currentPage, searchResult]);

  const handlePageChange = (_, value) => {
    setCurrentPage(value);
  };

  return (
    <>
      {loading ? (
        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center">
          <CircularProgress />
        </Paper>
      ) : (
        <Paper className="p-4" style={{ marginTop: "1rem" }}>
          <div>
            <Grid container spacing={2} alignItems="center" justifyContent="space-between">
              <Grid item xs={9}>
                <Typography variant="h5">Certification Module</Typography>
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="outlined-basic"
                  label=""
                  placeholder='Search'
                  variant="outlined"
                  value={searchResult}
                  onChange={(e) => setSearchResult(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }} />
              </Grid>
            </Grid>
          </div>
          {!certificates || certificates.length == 0 ?
            <Box>
              <div className='mt-4' style={{ color: '#555555' }}>
                There are no certificates available, please add them as needed.
              </div>

              <div className='inner-box'>
                <img src='/images/blur-logo.png' />
                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => setAddModal(true)}>
                  Create New Certificate
                </ButtonTheme>
              </div>
            </Box>
            :
            <div>
              <Row className='w-100 mt-4'>
                <Col md={5}>
                  <Row className='w-100'>
                    <Col md='auto'>
                      <img src='/images/users.png' style={{ width: 20, height: 20 }} />
                    </Col>
                    <Col md='auto' className='p-0'>
                      <div style={{ color: '#555555' }}>
                        Count of members holding this certificate
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col md={5}>
                  <Row className='w-100'>
                    <Col md='auto'>
                      <img src='/images/loc.png' style={{ width: 20, height: 20 }} />
                    </Col>
                    <Col md='auto' className='p-0'>
                      <div style={{ color: '#555555' }}>
                        Count of Positions
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className='mt-4 d-flex' style={{ justifyContent: 'space-between' }}>
                <Grid item xs={12}>
                  <Typography variant="h6">Available Certificates List</Typography>
                </Grid>
                <div className='d-flex gap-2 align-items-center'>
                  <Link to="/firehouse/certificates/all">
                    <ButtonTheme type='submit' variant="filled" color='primary'>
                      View All Certificate
                    </ButtonTheme>
                  </ Link>
                  <ButtonTheme type='submit' variant="filled" color='primary' onClick={() => setAddModal(true)}>
                    Create New Certificate
                  </ButtonTheme>
                </div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 10 }}>
                {certificates.map((cert) => (
                  <Col md={4}>
                    <div style={{
                      padding: '16px',
                      backgroundColor: '#ffffff',
                      borderRadius: '12px',
                      marginTop:'18px',
                      marginRight:'18px',
                      contain:'content',
                      minHeight:'230px',
                      border: '1px solid #EBECF0',
                      boxShadow: `
                      0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                      0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                      0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                    `,
                    }}>
                      <Row>
                        <Col md={7}>
                          <div className='title'>{cert.Name}</div>
                        </Col>
                        <Col md={5} className='p-0' style={{display:'flex' , justifyContent:'end'}}>
                          <Row className='w-100'>
                            <Col md={6}>
                              <Row className='w-100' style={{marginLeft:'10px'}}>
                                <Col md={2}>
                                  <img src='/images/loc.png' style={{ width: 20, height: 20 }} />
                                </Col>
                                <Col md={2}>
                                  <div style={{ color: '#555555' }}>
                                    {cert.certificate_positions_count}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={6}>
                              <Row className='w-100'>
                                <Col md={2}>
                                  <Link to={`/firehouse/certificate-members/${cert?.Certificate_id}`}>
                                    <img src='/images/users.png' style={{ width: 20, height: 20, cursor: 'pointer' }} />
                                  </Link>
                                </Col>
                                <Col md={2}>
                                  <div style={{ color: '#555555' }}>
                                    {cert.certificate_employees_count}
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div style={{height:'1px' , backgroundColor:'rgba(204, 204, 204, 0.6)' , marginTop:'10px'}}></div>
                      {cert?.Description &&
                        <p className={`desc ${cert.Description.length > 144 ? "line-clamp-3" : ""}`}>
                          {cert?.Description}
                        </p>
                      }
                      {cert.Description?.length > 144 && (
                        <p
                          onClick={() => {
                            setViewId(cert.Certificate_id)
                            setViewModal(true)
                          }}>
                          See More
                        </p>
                      )}
                      <Row className='btm-row'>
                        <Col md='auto'>
                          <img src='/images/eye.svg' style={{ cursor: 'pointer' }} onClick={() => {
                            setViewId(cert.Certificate_id)
                            setViewModal(true)
                          }} />
                        </Col>
                        <Col md='auto' className='p-0'>
                          <img src='/images/edit.svg' style={{ cursor: 'pointer' }} onClick={() => {
                            setAddModal(true)
                            setViewId(cert.Certificate_id)
                          }} />
                        </Col>
                        <Col md='auto'>
                          <img src='/images/delete.svg' style={{ cursor: 'pointer' }} onClick={() => {
                            setDeleteModal(true)
                            setDeleteId(cert.Certificate_id)
                          }} />
                        </Col>
                        <Col md='auto' className='p-0'>
                          <Link to={`/firehouse/certificate-members/${cert?.Certificate_id}`}>
                            <img src='/images/users.png' style={{ width: 20, height: 20, cursor: 'pointer' }} />
                          </Link>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              </div>
              <div className='mt-4'>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                  className="mt-4 d-flex"
                  style={{ justifyContent: 'end' }}
                />
              </div>
            </div>
          }
          <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete Certificate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ color: '#555555' }}>
                Are you sure to delete this Certificate?
              </div>
              <Row>
                <Col md='auto'>
                  <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setDeleteModal(false)}>
                    Cancel
                  </ButtonTheme>
                </Col>
                <Col md='auto'>
                  <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deleteCertificate}>
                    Delete
                  </ButtonTheme>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
          {addModal &&
            <AddCerificate addModal={addModal} setAddModal={setAddModal} editId={viewId}
              setViewId={setViewId} loadCertificates={loadCertificates} />
          }
          {viewModal &&
            <ViewCertificate id={viewId} viewModal={viewModal} setViewModal={setViewModal}
              setViewId={setViewId} />
          }
        </Paper>
      )}
    </>
  )
}

export default Certificates